import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';
import { MARKETING_APP_ENTRY_HREF } from '../marketingContent';

import styles from './FinalCTASection.module.css';

export function FinalCTASection() {
  return (
    <SectionWrapper background="navy" data-testid="faculty-section-final-cta">
      <div className={styles.section}>
        <h2 className={styles.title}>Try Kudu in your next class.</h2>
        <p className={styles.subhead}>
          Free to set up. Free to explore. Your students pay $25 a semester for
          the entire course.
        </p>
        <PrimaryCTA
          className={styles.cta}
          href={MARKETING_APP_ENTRY_HREF}
          icon={<ArrowRight aria-hidden="true" size={16} />}
          label="Start a free course"
        />
        <p className={styles.note}>
          Want to talk first?{' '}
          <Link to="/contact">Book a demo</Link>
          {' · '}
          <a href="mailto:support@kudu.com">support@kudu.com</a>
        </p>
      </div>
    </SectionWrapper>
  );
}
